module.exports = __webpack_public_path__ + "img/icons8-open-door-100.33f18d8f.png";